export { default } from './WelcomeWidget';